export let hres83eColumns = () => {
  let indexColumns = [{
    key: 'assetno',
    name: '',
    labelCodapp: 'HREP83EC',
    labelIndex: '40',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_assetno',
    name: '',
    labelCodapp: 'HREP83EC',
    labelIndex: '50',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_staappr',
    name: '',
    labelCodapp: 'HREP83EC',
    labelIndex: '60',
    class: 'align-center',
    style: 'min-width: 60px;'
  }, {
    key: 'timperiod',
    name: '',
    labelCodapp: 'HREP83EC',
    labelIndex: '70',
    class: 'align-center',
    style: 'min-width: 150px;'
  }, {
    key: 'desc_codempid',
    name: '',
    labelCodapp: 'HREP83EC',
    labelIndex: '80',
    style: 'min-width: 150px;'
  }, {
    key: 'desc_codcomp',
    name: '',
    labelCodapp: 'HREP83EC',
    labelIndex: '90',
    style: 'min-width: 200px;'
  }]

  let detailColumns = [{
    key: 'dtereq',
    name: '',
    labelCodapp: 'HREP83EC3',
    labelIndex: '50',
    class: 'align-center',
    style: 'min-width: 100px;',
    dataType: 'date'
  }, {
    key: 'desc_codempid',
    name: '',
    labelCodapp: 'HREP83EC3',
    labelIndex: '60',
    style: 'min-width: 150px;'
  }, {
    key: 'timperiod',
    name: '',
    labelCodapp: 'HREP83EC3',
    labelIndex: '70',
    class: 'align-center',
    style: 'min-width: 150px;'
  }, {
    key: 'desc_staappr',
    name: '',
    labelCodapp: 'HREP83EC3',
    labelIndex: '80',
    style: 'min-width: 60px;'
  }]

  return {
    en: {
      index: indexColumns,
      detail: detailColumns
    },
    th: {
      index: indexColumns,
      detail: detailColumns
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/columns/hres83e.js